import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-popup-login',
  templateUrl: './popup-login.component.html',
  styleUrls: ['./popup-login.component.scss'],
})
export class PopupLoginComponent {
  constructor(
    public router: Router,
    private dialogRef: MatDialogRef<PopupLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closePopup() {
    this.chance('no');
  }

  LogIn() {
    const url = this.router.url;

    this.router.navigate(['/login'], {
      queryParams: {
        next: url,
      },
    });
    this.dialogRef.close('no');
  }

  chance(chance: 'yes' | 'no' | 'login', results?: any): void {
    this.dialogRef.close({ action: chance, results });
  }
}
